import NoRobots from './NoRobots.component';

export default NoRobots;
